import { Injectable } from '@angular/core';

import * as signalR from "@microsoft/signalr";

import { HttpService } from './http.service';
import { LoadingBarService } from './loading-bar/loading-bar.service';
import { Subject } from './util/rxjs';

@Injectable()
export class JobService {
  private connection: any;
  private jobSubjectMap = new Map<string, Subject<shared.WebJobResponse>>();

  constructor(private loadingBar: LoadingBarService, private httpService: HttpService) {
	this.connection = new signalR.HubConnectionBuilder()
		.withUrl(this.signalrUrl)
		// .configureLogging(signalR.LogLevel.Trace)   // can be user for testing signalr
		.build();
    this.initializeHub();
  }

  startJob(url: string, payload: any, jobIdCallback?: (jobId: string) => void) {
    const subject = new Subject<shared.WebJobResponse>();

    this.httpService.post<any, any>(url, payload).subscribe(jobIdWrapper => {
      this.jobSubjectMap.set(jobIdWrapper.JobId, subject);

      if (jobIdCallback) {
        jobIdCallback(jobIdWrapper.JobId);
      }
    });

    return subject.asObservable();
  }

  connect() {
    return this.connection.start();
  }

  disconnect() {
    this.connection.stop();
  }

  private getBaseHref() {
    const base = document && document.getElementsByTagName('base');
    return base && base[0].href;
  }

  private get signalrUrl() {
    const base = this.getBaseHref();
    return base.endsWith('/') ? `${base}signalr` : `${base}/signalr`;
  }

  private initializeHub() {
      this.connection.on('onJobFinished', (response: shared.WebJobResponse) => {
	    // console.log("CP test: onJobFinished"); // can be user for testing signalr
      this.loadingBar.finishLoading();
      const subject = this.jobSubjectMap.get(response.JobId);

      // the job might have been cancelled
      if (subject) {
        this.jobSubjectMap.delete(response.JobId);

        // === shared.WebJobState.Success
        if (response.State === 0) {
          subject.next(response);
        } else {
          subject.error(response);
        }
      }
    });

     this.connection.on('onJobProgressChanged', (progress: shared.WebJobProgress) => {
	    // console.log("CP test: onJobProgressChanged"); // can be user for testing signalr
      return this.loadingBar.setProgress(progress.Progress);
    });
  }
}
